export const fr = {
  code: 'fr_fr',
  labels: {
    email: 'Email',
    password: 'Mot de passe',
    channels: 'Canal',
    device: 'Appareil EUI',
    pedestalQr: 'QR de la borne',
    pedestalName: 'Nom de la borne',
    scanCode: 'Scanner le code',
    addChannel: 'Ajouter un canal',
    editChannel: 'Modifier le canal',
    startReplacingCounter: 'Commencer à remplacer le compteur',
    finishReplacingCounter: 'Terminer le remplacement du compteur',
    removeChannel: 'Supprimer un canal',
    removeDevice: "Supprimer l'appareil",
    channelName: 'Nom du canal:',
    pulse: 'Impulsions par kWh',
    pulseWater: 'Impulsions par [m3]',
    maximumCurrent: 'Courant maximum [A]',
    voltage: 'Tension [VAC]',
    meterStatus: 'État du compteur [kWh]',
    meterStatusWater: 'État du compteur [m3]',
    addDevice: 'Ajouter un appareil',
    editDevice: 'Modifier un appareil',
    remove: 'Supprimer',
    lastSeen: 'Dernière fois vu:',
    never: 'Jamais',
    appVersion: "Version de l'application",
    attention: 'Attention!',
    testMode: 'Mode test',
    socketNumber: 'Numéro de prise',
    tapNumber: 'Numéro du robinet',
    channelNumber: 'N° (canal)',
    output: 'Sortie',
    unplug: 'Débrancher',
    editOutputs: 'Modifier les sorties',
    findDevice: "Scanner le code pour trouver l'appareil",
    modbusAddress: 'Adresse MODBUS',
    linkedChannel: 'Canal électrique lié',
    scanModBus: 'Scanner MODBUS',
    updatingOutputs: 'Mise à jour des sorties',
    updatingPMTags: 'Mise à jour des étiquettes PM',
    scanRequest: 'Demande de balayage',
    deviceErrors: "Erreurs de l'appareil",
    createdAt: 'Créé à',
    code: 'Code',
    description: 'Description',
    resolvedAt: 'Résolu à',
    resolvedBy: 'Résolu par',
    autoResolved: 'Résolu automatiquement',
    fixError: "Comment corriger l'erreur?",
    solution: 'Solution',
    pmTags: 'Tags PM',
    linkedTap: 'Robinet lié',
    linkedSocket: 'Prise liée',
    addingChannel: "Ajout d'un nouveau canal",
    updatingCounter: 'Mise à jour du compteur',
    profile: 'Profil',
    marinas: 'Marinas',
    changePassword: 'Changer de mot de passe',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    socket: 'Prise',
    tap: 'Robinet',
    switchingReason: 'Raison de la mise en marche du robinet/de la prise',
    customerReason: 'Connexion du client',
    repairReason: 'Réparation / test',
    technicalReason: 'Bateau technique / de service',
    boatName: 'Nom du bateau',
    berth: 'Emplacement',
    transient: 'Transitoire',
    yes: 'Oui',
    no: 'Non',
    comment: 'Commentaire',
  },
  descriptions: {
    removeChannel: 'Êtes-vous sûr de vouloir supprimer le canal?',
    removeDevice: "Êtes-vous sûr de vouloir supprimer l'appareil?",
    changesNotSaved: "Les modifications n'ont pas été enregistrées",
    leaveConfirmation: 'Êtes-vous sûr de vouloir partir?',
    enableLocation:
      "Votre emplacement est nécessaire pour déterminer la position de l'appareil. Veuillez activer l'autorisation dans les paramètres de votre navigateur.",
    typeChangeModal:
      "Êtes-vous sûr de vouloir changer le type d'appareil? Toutes les données du canal seront supprimées",
    changeSocketNumber:
      'Êtes-vous sûr de pouvoir changer le numéro de prise?',
    confirmChannelEnable:
      'Êtes-vous sûr de pouvoir déverrouiller ce canal?',
    confirmChannelDisable:
      'Êtes-vous sûr de pouvoir verrouiller ce canal?',
    confirmPMTagsEnable: "Êtes-vous sûr d'activer les balises PM?",
    confirmPMTagsDisable:
      'Etes-vous sûr de pouvoir désactiver les balises PM?',
    updating: "Cette opération peut prendre jusqu'à 3 minutes",
    scanModBus: "Je veux scanner l'adresse MODBUS de ce canal",
    wrongFirmwareForTestMode:
      "Veuillez mettre à jour le micrologiciel de l'appareil avant d'activer le mode test.",
    skippedChannel:
      'Rafraîchir les données ou vérifier la connexion physique de la prise dans le socle.',
    startReplaceCounter:
      'Êtes-vous sûr de vouloir commencer à remplacer le compteur?',
  },
  placeholders: {
    email: 'email@example.com',
    password: '********',
    search: 'Recherche',
    pier: 'Quai',
    pedestal: 'Borne',
    chooseCamera: 'Choisir la caméra',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    enterComment: 'Saisir un commentaire',
  },
  buttons: {
    login: 'Se connecter',
    logout: 'Se déconnecter',
    back: 'Retourner',
    refresh: 'Actualiser',
    save: 'Sauvegarder',
    remove: 'Supprimer',
    addChannel: 'Ajouter un canal',
    enable: 'Activer',
    lock: 'Verrouiller',
    electricity: 'Électricité',
    water: 'Eau',
    add: 'Ajouter',
    replace_device: 'Remplacer MM-E',
    replace_counter: 'Remplacer le compteur',
    replace_pedestal_code: 'Remplacer QR',
    savePosition: 'Enregistrer la nouvelle position',
    cancel: 'Annuler',
    hide: 'Masquer',
    confirm: 'Confirmer',
    getPosition: 'Obtenir la position',
    resolve: 'Résoudre',
    startScan: 'Démarrer le balayage',
    stopScan: 'Arrêter la numérisation',
    scanImage: "Numériser l'image",
    supportRequest: "Envoyer une demande d'assistance",
    profile: 'Profil',
    marinas: 'Marinas',
    start: 'Commencer',
    finish: 'Finir',
  },
  legend: {
    title: 'Légende',
    neverSeen: 'dispositif jamais vu',
    notSynced: 'dispositif non vu dans les 20 dernières minutes',
    hasErrors:
      'dispositif a des erreurs non résolues (intervention nécessaire)',
  },
  notifications: {
    addedDevice: 'Dispositif ajouté 👍',
    updatedGeo: 'Position mise à jour 👍',
    updatedEui: "Mise à jour de l'IUE de l'appareil 👍",
    updatedPedestalQr: 'QR du piédestal mis à jour 👍',
    replacedCounter: 'Remplacement du compteur 👍',
    startedReplaceCounter: 'Début du remplacement du compteur 👍',
    replacedCounterNewValue:
      'Nouveau statut du compteur: <strong>{{meter_status}} {{unit}}</strong>',
    addedChannel: 'Canal ajouté 👍',
    removedChannel: 'Canal supprimé 👍',
    changedChannelState: 'État du canal modifié 👍',
    removedDevice: 'Dispositif supprimé 👍',
    invalidValues: 'Valeurs non valides ⚡',
    updatedOutputs: "Les sorties de l'appareil sont réglées correctement",
    error: 'Erreur 🤥',
    success: 'Succès',
    errorMessage: "Quelque chose s'est mal passé",
    tryAgain: 'Veuillez réessayer',
    notSeenOnSubmit:
      "L'appareil n'est pas vu. Assurez-vous que les données ont été sauvegardées correctement.",
    invalidDeviceName:
      "Les champs du nom de l'appareil ne sont pas valides. Veuillez compléter les champs",
    invalidPedestalQrLength:
      'Le QR du piédestal doit comporter au moins 6 caractères',
    enableLocation:
      'Vous devez activer votre permission de géolocalisation',
    testModeEnabled: 'Le mode test est maintenant activé',
    testModeDisabled: 'Le mode test est maintenant désactivé',
    pmTagsEnabled: "L'option PM Tags est désormais activée",
    pmTagsDisabled: 'Les étiquettes PM sont maintenant désactivées',
    deviceNotFound: "Cet appareil n'a pas été trouvé",
    typeNotSupported: "Ce type n'est pas supporté",
    preventTypeChange: `Vous ne pouvez pas modifier le type d'appareil`,
    socketNumbersUnique:
      'Les valeurs des numéros de prises doivent être uniques',
    addDeviceNow: "Vous pouvez l'ajouter maintenant!",
    uniqueLinks:
      "Les liens entre les canaux d'eau et d'électricité doivent être uniques",
    scanRequested:
      "Une demande d'analyse a été envoyée. L'analyse peut prendre jusqu'à 10 minutes.",
    errorResolved: 'Erreur résolue 👍',
    qrNotFound: "Aucun code QR n'a été trouvé",
    supportRequest: 'Votre demande a été envoyée au support technique',
    passwordChanged: 'Le mot de passe a été modifié avec succès',
  },
  errors: {
    devEui: "L'IUE ne doit pas être vide",
    channels: 'Les canaux doivent contenir au moins 1 élément',
    newDevEui: "L'EUI du nouveau dispositif ne doit pas être vide",
    pulse: "L'impulsion ne doit pas être indéfinie",
    meterStatus: "L'état du compteur ne doit pas être indéfini",
    userNotFound: "L'utilisateur n'a pas été trouvé",
    wrongPassword: "Le mot de passe n'est pas valide",
    physicalName: "La valeur du nom physique n'est pas valide",
    pedestalQr: "La valeur QR du piédestal n'est pas valide",
    modBus: "La valeur MODBUS n'est pas valide",
  },
  validations: {
    invalid: "La valeur n'est pas valide.",
    required: 'Le champ est obligatoire.',
    email: "L'email n'est pas valide.",
    wrongMarina: "Le code QR scanné provient d'une autre marina.",
    wrongEui: "Cet EUI n'est pas correct",
    wrongPedestalQr: "Ce code n'est pas correct",
    wrongPedestalName: "Le nom du piédestal scanné n'est pas correct",
    passwordLength: 'Le mot de passe doit comporter au moins 8 caractères',
    strongPassword:
      'Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial',
    samePasswords: 'Les mots de passe doivent être identiques',
  },
  notFound: {
    title: 'Oh, non!',
    description:
      "Malheureusement, la page n'a pas été trouvée. Veuillez utiliser le bouton ci-dessous pour revenir à la page d'accueil et réessayer.",
    button: "Retourner à la page d'accueil",
  },
  deviceErrors: {
    1: {
      description: "Le micrologiciel téléchargé n'est pas valide",
      instruction: "Remplacez l'appareil",
    },
    2: {
      description: "Le firmware téléchargé n'est pas valide",
      instruction:
        "Configurez FUOTA avec la version matérielle correcte pour l'appareil",
    },
    3: {
      description: 'Erreur de communication MODBUS {{arg0}}',
      arg0: 'pour le canal n°. {{arg}}',
      instruction:
        "Vérifiez l'électronique de la prise, le faisceau de câbles et toutes les connexions physiques.",
    },
    4: {
      description: 'Échec du balayage MODBUS {{arg0}} {{arg1}}',
      arg0: 'pour le canal n°. {{arg}}',
      instruction:
        "Vérifiez l'électronique de la prise, le faisceau de câbles et toutes les connexions physiques.",
    },
    5: {
      description:
        'Réinitialisation exécutée par le chien de garde {{arg0}}',
      arg0_0: '(chien de garde IWDG)',
      arg0_1: '(chien de garde WWDG)',
    },
    6: {
      description: 'Crédits utilisateur écrasés {{arg0}} {{arg1}}',
      arg0: '(nombre de crédits: {{arg}}).',
      arg1: 'N° du canal pour lequel les crédits ont été écrasés: {{arg}}',
      instruction:
        'Vérifiez si les crédits écrasés doivent être restitués au client. Signalez la situation au bureau pour vérification.',
    },
    7: {
      description: "L'appareil a perdu la communication",
    },
    8: {
      description: 'Remplacez ou mettez à jour le Plus {{arg0}}}',
      arg0: 'socket no. {{arg}}',
      instruction:
        'Remplacez la prise par une prise avec le firmware 1.29 ou mettez à jour le firmware de la prise à 1.29.',
    },
    defaultSolution:
      "Si vous avez un problème pour résoudre l'erreur, veuillez contacter le support technique",
  },
};
